import React from "react";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import MemberSidebar from "../../inc/MemberSidebar";
import iconTrash from "../../img/icons/icon-trash.svg";
import iconPencil from "../../img/icons/icon-pencil.svg";
import 'react-quill/dist/quill.snow.css';
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import MD5 from "crypto-js/md5";

export default function BusinessSoftware(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let formId = decode.id;
    let code = decode.code;
    let status = decode.status;

    let member = prop.member;
    let [listing, setListing] = React.useState(null);
    let [showForm, setShowForm] = React.useState(false);
    let [isReadonly, setIsReadonly] = React.useState(false);
    let [editId, setEditId] = React.useState(null);
    let [data, setData] = React.useState(null);

    let refTitle = React.useRef();
    let refDetail = React.useRef();
    let refVersion = React.useRef();

    //ไฟล์แนบ
    let [base64, setBase64] = React.useState(null);
    let refFileName = React.useRef();
    let refFile = React.useRef();
    const handleClick = React.useCallback(() => refFile.current?.click(), []);
    let [currentFile, setCurrentFile] = React.useState(null);

    React.useEffect(() => {
        document.title = 'ข้อมูลอุปกรณ์และซอฟท์แวร์ - NCSA';

        (async function() {
            try {

                const result = await getListing();
                setListing(result);

            } catch (e) {
                //
            }
        })();

    }, []);

    async function getListing() {
        const response = await fetch(Config.apiUrl +'/cyberSoftware/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                formId: formId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onAddNew = () => {
        refTitle.current.value = '';
        refDetail.current.value = '';
        refVersion.current.value = '';
        refFileName.current.value = '';
        setCurrentFile(null);
        setBase64(null);
        setShowForm(true);
        setEditId(null);
    };

    const onCancel = () => {
        setShowForm(false);
    };

    const onEdit = async (id) => {
        const result = await getView(id);
        if(result) {
            setData(result);
            setEditId(id);
            setShowForm(true);
            refTitle.current.value = result.title;
            refDetail.current.value = result.detail;
            refVersion.current.value = result.version;

            if(result.file) {
                setCurrentFile(Config.fileUpload + "cyber_software_file/" + result.file);
            }
        }
    };

    const onView = async (id) => {
        await onEdit(id);
        setIsReadonly(true);
    };

    const onSubmit = () => {
        let title = refTitle.current.value;
        let detail = refDetail.current.value;
        let version = refVersion.current.value;
        let fileName = refFileName.current.value;

        if(!title) {
            toast.error(prop.lang === 'en' ? 'Please specify title':'กรุณาระบุ ชื่ออุปกรณ์และซอฟท์แวร์');
            refTitle.current.focus();
        }
        else if(!detail) {
            toast.error(prop.lang === 'en' ? 'Please specify detail':'กรุณาระบุ รายละเอียดการใช้งาน');
            refDetail.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {

                            let file = data?.file ?? null;
                            if(fileName) {
                                file = MD5(moment().format("YMMDDHHmmss") + '111').toString() + '.' + fileName.split('.').pop();
                            }

                            let param = {
                                id: editId,
                                formId: formId,
                                title: title,
                                detail: detail,
                                version: version,
                                file: file,
                                currentFile: data?.file,
                                base64: base64,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createItem(param);

                            if(result) {
                                if(result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'Add team successfully.':'บันทึกข้อมูล เรียบร้อย');
                                    setTimeout(async function () {
                                        onAddNew();
                                        setShowForm(false);
                                        const teamRes = await getListing();
                                        setListing(teamRes);
                                    }, 1000);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function createItem(param) {
        const response = await fetch(Config.apiUrl +'/cyberSoftware/' + (editId ? 'updateByMember':'createByMember'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getView(id) {
        const response = await fetch(Config.apiUrl +'/cyberSoftware/viewByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteItem(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                const teamRes = await getListing();
                                setListing(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function deleteItem(id) {
        const response = await fetch(Config.apiUrl +'/cyberSoftware/deleteByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="businessForm" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="d-flex justify-content-between gap-3">
                                <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Quality Form':'แบบฟอร์มคำร้องขอการรับรองคุณภาพ'}</h3>
                                <NavLink to={'/businessForm'} className="btn btn-xs btn-gray">&larr; กลับไป</NavLink>
                            </div>

                            <div className="d-flex justify-content-between gap-3">
                                <h6 className="pt-1">ข้อมูลอุปกรณ์และซอฟท์แวร์ เลขที่คำขอ : {code}</h6>
                                {
                                    !showForm && (status === Utils.FORM_STATUS_DRAFT || status === Utils.FORM_STATUS_EDIT || status === Utils.FORM_STATUS_EVALUATION_EDIT) ? <button className="btn btn-xs btn-light-2" onClick={onAddNew}>+ เพิ่มข้อมูล</button> : ''
                                }
                            </div>

                            <div className={(showForm ? ' d-none':'')}>
                                <div className="table-responsive mt-3">
                                    <table className="table table-info table-hover text-center">
                                        <thead>
                                        <tr>
                                            <th className="text-start">ชื่ออุปกรณ์และซอฟท์แวร์</th>
                                            <th>เอกสารดาวน์โหลด</th>
                                            <th>วันที่สร้าง</th>
                                            <th>วันที่อัพเดต</th>
                                            <th style={{width:'130px'}}>เครื่องมือ</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {
                                            listing && listing.count > 0 ?
                                                listing.rows.map((row, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-start">
                                                                {row.title}
                                                                {row.version ? <p className="text-muted">เวอร์ชั่น : {row.version}</p> : ''}
                                                            </td>
                                                            <td>
                                                                {
                                                                    row.file ? <NavLink to={Config.fileUpload + "cyber_software_file/" + row.file} className="btn btn-xs btn-gray me-auto" target="_blank">&darr; ดาวน์โหลด</NavLink> : ''
                                                                }
                                                            </td>
                                                            <td className="text-center">{Utils.dateTimeText(row.createdAt)}</td>
                                                            <td className="text-center">{Utils.dateTimeText(row.updatedAt)}</td>
                                                            <td>
                                                                <div className="d-flex justify-content-center gap-2">
                                                                    {
                                                                        status === Utils.FORM_STATUS_DRAFT || status === Utils.FORM_STATUS_EDIT || status === Utils.FORM_STATUS_EVALUATION_EDIT ?
                                                                            <>
                                                                                <button className="btn btn-trans"
                                                                                        onClick={e => onEdit(row.id)}>
                                                                                    <img className="icons svg-js"
                                                                                         src={iconPencil} alt=""/>
                                                                                </button>
                                                                                <button className="btn btn-trans"
                                                                                        onClick={e => onDelete(row.id)}>
                                                                                    <img className="icons svg-js trash"
                                                                                         src={iconTrash} alt=""/>
                                                                                </button>
                                                                            </> :
                                                                            <button className="btn btn-xs btn-gray me-auto" onClick={e => onView(row.id)}>รายละเอียด</button>
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : <tr><td colSpan={5} className="text-center">ไม่พบข้อมูล</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className={"row g-3 mt-2" + (showForm ? '':' d-none')}>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <h6>ชื่ออุปกรณ์และซอฟท์แวร์ <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refTitle} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <h6>เวอร์ชั่น</h6>
                                        <input type="text" className="form-control" ref={refVersion} maxLength={250} readOnly={isReadonly} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <h6>รายละเอียดการใช้งาน <span className="star">*</span></h6>
                                        <textarea className="form-control" id="detail" ref={refDetail} maxLength={5000} rows={10} style={{height:'200px'}} readOnly={isReadonly}></textarea>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <h6>ไฟล์แนบ</h6>

                                        {
                                            !isReadonly ?
                                                <>
                                                    <div className="input-group">
                                                        <input type="text" className="form-control" ref={refFileName} readOnly={true} />
                                                        <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClick}>เลือกไฟล์</button>
                                                        <button type="button" className={"input-group-text" + (base64 ? ' d-block':' d-none')} onClick={e => {
                                                            refFileName.current.value = '';
                                                            setBase64('');
                                                        }}>ลบ</button>
                                                    </div>
                                                    <p className="small text-danger my-1">* ชนิดไฟล์ .pdf ขนาดไม่เกิน {Utils.maxFileSize5Mb}MB</p>
                                                    <input type="file" className="form-control d-none" ref={refFile} onChange={(e) => {
                                                        Utils.onSelectFile(e).then(
                                                            data => {
                                                                if(data) {
                                                                    refFileName.current.value = e.target.files[0].name;
                                                                    setBase64(data);
                                                                }
                                                            }
                                                        );
                                                    }} accept={Utils.allowPdfExtension} />
                                                </> : ''
                                        }

                                        {
                                            currentFile !== null ?
                                                <div className="col-12">
                                                    <NavLink to={currentFile} target="_blank" className="btn btn-xs btn-gray w-180">&darr; ดาวน์โหลด ไฟล์ปัจจุบัน</NavLink>
                                                </div> : ''
                                        }
                                    </div>
                                </div>

                                <div className="col-12 mt-4">
                                    {
                                        !isReadonly ?
                                            <div className="buttons gap-15 py-0">
                                                <button className="btn btn-xs btn-green" type="button" onClick={onSubmit}>
                                                    {prop.lang === 'en' ? 'Save':'บันทึก'}
                                                </button>
                                                <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onCancel}>
                                                    {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                                                </button>
                                            </div> : ''
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 